import { GetListParams } from 'react-admin';
import { CustomDataProvider, registerModuleDataProvider } from '../../providers/CustomDataProvider';
import { listPendingWithdrawals } from '../../services/xpxPerpsWithdrawalService';

const resourceName = 'xpx-perps/withdrawal';

export const xpxPerpsWithdrawalDataProvider: CustomDataProvider = {
  async getList(_resource: string, params: GetListParams): Promise<any> {
    const { page = 1, perPage = 20 } = params.pagination || {};

    const response = await listPendingWithdrawals(page, perPage);
    const { items = [], total } = response.data;

    return {
      data: items.map((item: any) => ({ ...item, id: item.id })),
      total: Number(total) || 0,
    };
  },
};

registerModuleDataProvider(resourceName, xpxPerpsWithdrawalDataProvider);
